(() => {
  const openBase = '.camping-base-open-js';
  const closeBase = '.camping-base-close-js';
  const baseInfo = '.camping-base-info-js';
  const openOption = '.camping-option-open-js';
  const closeOption = '.camping-option-close-js';
  const optionInfo = '.camping-option-info-js';
  const openCoupon = '.camping-coupon-open-js';
  const closeCoupon = '.camping-coupon-close-js';
  const couponInfo = '.camping-coupon-info-js';
  const openSubscription = '.camping-subscription-open-js';
  const closeSubscription = '.camping-subscription-close-js';
  const subscriptionInfo = '.camping-subscription-info-js';

  const init = () => {
    if (location.href.indexOf('customer/camping') < 1 ) {
      return;
    }

    $(baseInfo).hide();
    $(closeBase).hide();
    $(optionInfo).hide();
    $(closeOption).hide();
    $(couponInfo).hide();
    $(closeCoupon).hide();
    $(subscriptionInfo).hide();
    $(closeSubscription).hide();

    $('body')
      .on('click', openBase, openBaseInfo)
      .on('click', closeBase, closeBaseInfo)
      .on('click', openOption, openOptionInfo)
      .on('click', closeOption, closeOptionInfo)
      .on('click', openCoupon, openCouponInfo)
      .on('click', closeCoupon, closeCouponInfo)
      .on('click', openSubscription, openSubscriptionInfo)
      .on('click', closeSubscription, closeSubscriptionInfo);
  }

  const openBaseInfo = () => {
    $(openBase).fadeOut().attr('style', 'display: none !important');
    $(closeBase).fadeIn().attr('style', 'display: block !important');
    $(baseInfo).fadeIn().attr('style', 'display: block !important');
  }

  const closeBaseInfo = () => {
    $(openBase).fadeIn().attr('style', 'display: block !important');
    $(closeBase).fadeOut().attr('style', 'display: none !important');
    $(baseInfo).fadeOut().attr('style', 'display: none !important');
  }

  const openOptionInfo = () => {
    $(openOption).fadeOut().attr('style', 'display: none !important');
    $(closeOption).fadeIn().attr('style', 'display: block !important');
    $(optionInfo).fadeIn().attr('style', 'display: block !important');
  }

  const closeOptionInfo = () => {
    $(openOption).fadeIn().attr('style', 'display: block !important');
    $(closeOption).fadeOut().attr('style', 'display: none !important');
    $(optionInfo).fadeOut().attr('style', 'display: none !important');
  }

  const openCouponInfo = () => {
    $(openCoupon).fadeOut().attr('style', 'display: none !important');
    $(closeCoupon).fadeIn().attr('style', 'display: block !important');
    $(couponInfo).fadeIn().attr('style', 'display: block !important');
  }

  const closeCouponInfo = () => {
    $(openCoupon).fadeIn().attr('style', 'display: block !important');
    $(closeCoupon).fadeOut().attr('style', 'display: none !important');
    $(couponInfo).fadeOut().attr('style', 'display: none !important');
  }

  const openSubscriptionInfo = () => {
    $(openSubscription).fadeOut().attr('style', 'display: none !important');
    $(closeSubscription).fadeIn().attr('style', 'display: block !important');
    $(subscriptionInfo).fadeIn().attr('style', 'display: block !important');
  }

  const closeSubscriptionInfo = () => {
    $(openSubscription).fadeIn().attr('style', 'display: block !important');
    $(closeSubscription).fadeOut().attr('style', 'display: none !important');
    $(subscriptionInfo).fadeOut().attr('style', 'display: none !important');
  }

  $(init)
})();
